/**
 * Shared schedule/details control for module tables that surface appointment actions.
 */

import React from 'react';
import { Button } from 'antd';
import { CalendarOutlined } from '@ant-design/icons';

/** Props for the shared appointment schedule/details button. */
export interface AppointmentScheduleButtonProps {
  /** Whether the row already has a linked appointment. */
  hasAppointment: boolean;
  /** Label when no appointment exists yet. */
  scheduleLabel: string;
  /** Label when an appointment already exists. */
  detailsLabel: string;
  /** Opens the create-appointment flow. */
  onSchedule: () => void;
  /** Opens appointment details; receives the click event for anchor positioning. */
  onDetails: (e: React.MouseEvent<HTMLElement>) => void;
  /** Disables interaction when scheduling is unavailable. */
  disabled?: boolean;
}

/** Toggles between scheduling a new appointment and opening existing appointment details. */
export function AppointmentScheduleButton({
  hasAppointment,
  scheduleLabel,
  detailsLabel,
  onSchedule,
  onDetails,
  disabled,
}: AppointmentScheduleButtonProps) {
  return (
    <Button
      type={hasAppointment ? 'default' : 'primary'}
      icon={<CalendarOutlined />}
      size="small"
      disabled={disabled}
      onClick={(e) => {
        if (hasAppointment) onDetails(e);
        else onSchedule();
      }}
    >
      {hasAppointment ? detailsLabel : scheduleLabel}
    </Button>
  );
}
